export type CsrdOnDemandAttributes = { jobId: number };

export enum CsrdViewSubPage {
  OVERVIEW = 'overview',
  MATERIALITY_RESULTS = 'materiality-results',
  FINANCIAL_EFFECTS = 'financial-effects',
  // TODO should this be removed?
  STATEMENT_COUNTS = 'statement-counts',
  PRODUCT_INPUT = 'product-input',
}
